import moment from 'moment';
import H_time from '@/helpers/time';
import H_file from '@/helpers/file';
import H_common from '@/helpers/common';

export default {
  setShow({
    id,
    name,
    announce_at,
    effect_at,
    remark,
    attaches,
    act_version_alls,
    article_versions,
    related_guidelines,
    has_audit,
    has_checklist,
    has_guideline_article_version,
    has_guideline_version,
    has_internal_training,
    has_license,
    has_task,
    has_related_models: hasRelatedModels,
  }) {
    return {
      id,
      name,
      announceAt: H_time.getDateDashFormat(announce_at),
      effectAt: H_time.getDateDashFormat(effect_at),
      remark,
      attaches: H_file.setShowInModule(attaches),
      lawCardList: this.setLawCardList({act_version_alls, article_versions}),
      guidelineList: this.setShowRelatedGuideline(related_guidelines),
      has_audit,
      has_checklist,
      has_guideline_article_version,
      has_guideline_version,
      has_internal_training,
      has_license,
      has_task,
      hasRelatedModels,
    };
  },
  setLawCardList({act_version_alls, article_versions}) {
    const act = act_version_alls.map(({id: versionId, name: title, act: {id}}) => ({
      id,
      title,
      versionId,
      type: 'act',
    }));
    const article = article_versions.map(({article: {id}, act_version, act_versions, no_text, id: versionId, }) => {
      return {
        id,
        title: `${
          act_version
            ? act_version.name
            : act_versions[0].name
        } ${no_text ? no_text : ""}`,
        versionId,
        actVersionId: act_version
          ? act_version.id
          : act_versions[act_versions.length -1].id,
        type: 'article',
      };
    });
    return [...act, ...article];
  },
  setUpdateSubmit({
    name,
    announceAt,
    effectAt,
    remark,
    attaches,
    lawList,
    guidelineList,
  }) {
    const { actVersionAlls: act_version_alls, articleVersions: article_versions } = H_common.setSubmitActAndArticle(lawList);
    return {
      name,
      announce_at: H_time.getDateDashFormat(announceAt, 'YYYY-MM-DD HH:mm:ssZ'),
      effect_at: H_time.getDateDashFormat(effectAt, 'YYYY-MM-DD HH:mm:ssZ'),
      remark,
      reference_link: '',
      attaches: H_file.setSubmitInModule(attaches),
      article_versions,
      act_version_alls,
      related_guidelines: this.setSubmitRelatedGuideline(guidelineList),
    };
  },
  setSortSubmit(rawDataList) {
    const order = [];
    function setSortItem(item, parentSequence = null, parentId, index = 0) {
      const sequence = parentSequence ? `${parentSequence}-${(index + 1).toString().padStart(4, '0')}` : (index + 1).toString().padStart(4, '0');
      order.push({ id: item.id, parentId, sequence });
      if (item.children && item.children.length > 0) {
        item.children.forEach((child, childIndex) => {
          setSortItem(child, sequence, item.id, childIndex);
        });
      }
    }
    rawDataList.forEach((item, index) => {
      setSortItem(item, null, '', index);
    });
    return order;
  },
  setIndexAnnounceToDate(rawDataList) {
    return rawDataList.map(({
      id,
      announce_at,
      effect_at
    }) => ({
      id,
      announceAt: moment(announce_at).toDate(),
      effectAt: moment(effect_at).toDate(),
    }));
  },
  setSubmitRelatedGuideline(guidelineList) {
    if (!guidelineList) return [];
    return guidelineList.map(({
      guideline_id,
      guideline_version_id,
      guideline_article_id,
      guideline_article_version_id,
    }) => ({
      guideline_id,
      ...(guideline_version_id && { guideline_version_id }),
      ...(guideline_article_id && { guideline_article_id }),
      ...(guideline_article_version_id && { guideline_article_version_id })
    }));
  },
  setShowRelatedGuideline(rawDataList) {
    if (!rawDataList) return [];
    return rawDataList.map(({
      guideline,
      guideline_version,
      guideline_article,
      guideline_article_version,
    }) => {
      const baseInfo = {
        type: 'guideline',
        title: '',
        guidelineId: guideline.id,
        guidelineVerId: '',
        articleVerId: '',
        guideline,
        guideline_version,
        guideline_article,
        guideline_article_version,
      };
      if (guideline_article_version) {
        const {id, name, no_text, announce_at, type} = guideline_article_version;
        return {
          ...baseInfo,
          type,
          title: `${name || no_text}${announce_at ? ` (${H_time.getDateDashFormat(announce_at)})` : ''}`,
          guidelineVerId: guideline_version.id,
          articleVerId: id,
        };
      } else if (guideline_article) {
        const {id, name, no_text, type} = guideline_article.last_version;
        return {
          ...baseInfo,
          type,
          title: `${name || no_text} (Latest)`,
          articleVerId: id,
        };
      } else if (guideline_version) {
        const {id, name, announce_at} = guideline_version;
        return {
          ...baseInfo,
          title: `${name} (${H_time.getDateDashFormat(announce_at)})`,
          guidelineVerId: id,
        };
      } else if (guideline) {
        return {
          ...baseInfo,
          title: `${guideline.name} (Latest)`,
        };
      }
    });
  },
  setUpdateRelatedGuideline(rawDataList) {
    if (!rawDataList) return [];
    return rawDataList.map(({
      guideline,
      guideline_version,
      guideline_article,
      guideline_article_version,
    }) => {
      const guideline_version_id = guideline_version ? guideline_version.id : '';
      const guideline_article_id = guideline_article ? guideline_article.id : '';
      const guideline_id = guideline ? guideline.id : '';
      if (guideline_article_version) {
        return {
          guideline_article_version_id: guideline_article_version.id,
          guideline_article_id,
          guideline_version_id,
          guideline_id,
          name: `${guideline_article_version.name} (${H_time.getDateDashFormat(guideline_article_version.announce_at)})`,
          type: guideline_article_version.type,
          articleVerId: guideline_article_version.id,
        };
      } else if (guideline_article) {
        return {
          guideline_article_id,
          guideline_version_id,
          guideline_id,
          name: `${guideline_article.last_version.name} (Latest)`,
          type: guideline_article.last_version.type,
          articleVerId: guideline_article.last_version.id,
        };
      } else if (guideline_version) {
        return {
          guideline_version_id,
          guideline_id,
          name: `${guideline_version.name} (${H_time.getDateDashFormat(guideline_version.announce_at)})`,
          type: 'guideline',
        };
      } else if (guideline) {
        return {
          guideline_id,
          name: `${guideline.name} (Latest)`,
          type: 'guideline',
        };
      }
    })
  },
  setShowToSubmitRelatedGuideline(rawDataList) {
    if (!rawDataList) return [];
    return rawDataList.map(({
      guideline,
      guideline_version,
      guideline_article,
      guideline_article_version,
    }) => {
      const guideline_version_id = guideline_version ? guideline_version.id : '';
      const guideline_article_id = guideline_article ? guideline_article.id : '';
      const guideline_id = guideline ? guideline.id : '';
      if (guideline_article_version) {
        return {
          guideline_article_version_id: guideline_article_version.id,
          guideline_article_id,
          guideline_version_id,
          guideline_id,
        };
      } else if (guideline_article) {
        return {
          guideline_article_id,
          guideline_version_id,
          guideline_id,
        };
      } else if (guideline_version) {
        return {
          guideline_version_id,
          guideline_id,
        };
      } else if (guideline) {
        return {
          guideline_id,
        };
      }
    })
  },
};
